import React from 'react'

//////////////////////// Clipboard /////////////////////////

export type ClipboardType = {
  type: string
  value: any
}
export type SetClipboardType = React.Dispatch<React.SetStateAction<ClipboardType>>

export const ClipboardContext = React.createContext<{
  clipboard: ClipboardType
  setClipboard: SetClipboardType
}>({ clipboard: null, setClipboard: () => {} })

//////////////////////// Track Refs /////////////////////////

export type RefsType = { [stemID: string]: HTMLDivElement }
export type SaveRefType = (stemID: string) => (ref: HTMLDivElement) => void
export type TrackRefsType = {
  refs: RefsType
  saveRef: SaveRefType
}

export const TrackRefsContext = React.createContext<TrackRefsType>({
  refs: {},
  saveRef: () => () => {}
})
